export const getInitials = (first: string, last: string): string => {
  const firstInitial = first?.charAt(0).toUpperCase() ?? '';
  const lastInitial = last?.charAt(0).toUpperCase() ?? '';
  return `${firstInitial}${lastInitial}` || '?';
};

export const STAR_MAP: Record<number, string> = {
  5: '★★★★★',
  4: '★★★★☆',
  3: '★★★☆☆',
  2: '★★☆☆☆',
  1: '★☆☆☆☆',
};

export const timeAgo = (isoString: string): string => {
  const diff = Date.now() - new Date(isoString).getTime();
  const days = Math.floor(diff / 86_400_000);
  if (days < 30) return `${days} day${days === 1 ? '' : 's'} ago`;
  const months = Math.floor(days / 30);
  if (months < 12) return `${months} month${months === 1 ? '' : 's'} ago`;
  const years = Math.floor(months / 12);
  return `${years} year${years === 1 ? '' : 's'} ago`;
};

export const formatDateShort = (isoString: string): string =>
  new Date(isoString).toLocaleDateString('en-ZA', {
    month: 'short',
    year: 'numeric',
  });

const RECENT_THRESHOLD_SECONDS = 45;
const MINUTE = 60;
const HOUR = 60 * 60;
const DAY = 24 * 60 * 60;

export const formatLastSeen = (
  isoString: string | null | undefined,
): string => {
  if (!isoString) return 'offline';
  const diff = Math.max(
    0,
    Math.floor((Date.now() - new Date(isoString).getTime()) / 1000),
  );
  if (diff < MINUTE) return 'last seen just now';
  if (diff < HOUR) {
    const minutes = Math.floor(diff / MINUTE);
    return `last seen ${minutes} minute${minutes === 1 ? '' : 's'} ago`;
  }
  if (diff < DAY) {
    const hours = Math.floor(diff / HOUR);
    return `last seen ${hours} hour${hours === 1 ? '' : 's'} ago`;
  }
  const days = Math.floor(diff / DAY);
  return `last seen ${days} day${days === 1 ? '' : 's'} ago`;
};

export const isRecentlyOnline = (
  isoString: string | null | undefined,
): boolean => {
  if (!isoString) return false;
  const diff = Math.max(
    0,
    Math.floor((Date.now() - new Date(isoString).getTime()) / 1000),
  );
  return diff <= RECENT_THRESHOLD_SECONDS;
};

export const formatCompactNumber = (num: number): string => {
  if (num < 1_000) return String(num);
  if (num < 1_000_000) {
    const thousands = num / 1_000;
    return thousands % 1 === 0 ? `${thousands}k` : `${thousands.toFixed(1).replace(/\.0$/, '')}k`;
  }
  const millions = num / 1_000_000;
  return millions % 1 === 0 ? `${millions}m` : `${millions.toFixed(1).replace(/\.0$/, '')}m`;
};
